import Ajax from "@/js/common/ajax";
import Qs from "qs";

export default {
	autoReconciliation(params) {
		return Ajax.post("/reconciliation/auto", params)
	},
	doReconciliation(params) {
		return Ajax.post("/reconciliation/do", params)
	},
	cancelReconciliation(params) {
		return Ajax.post("/reconciliation/cancel", params)
	},
	cancelAllReconciliation(params) {
		return Ajax.post("/reconciliation/cancel/all", params)
	},
	reconciliationBalance(params) {
		return Ajax.post("/reconciliation/balance", params)
	},
	reconciliationBalanceTable(params) {
		return Ajax.post("/reconciliation/balance/table", params)
	}
}
